import React from 'react'
import { PatientHistoryType } from 'src/graphql.generated'
import ScoreQuestionnaireFields from './ScoreQuestionnaireFields'

const GAD7_QUESTIONS = [
  'Feeling nervous, anxious or on edge?',
  'Not being able to stop or control worrying?',
  'Worrying too much about different things?',
  'Trouble relaxing?',
  'Being so restless that it is hard to sit still?',
  'Becoming easily annoyed or irritable?',
  'Feeling afraid as if something awful might happen?',
]

const GAD7Fields = ({ uid }: { uid: string }) => (
  <ScoreQuestionnaireFields
    uid={uid}
    type={PatientHistoryType.Gad7}
    title="GAD-7"
    prefix="GAD7"
    questions={GAD7_QUESTIONS}
  />
)

export default GAD7Fields
